import cartPage from "../../../services/cart/cart";

const actions = {
  updateCart(context, data) {
    context.commit('updateCart', data.cart, {root: true});
    context.commit('updateCartCount', data, {root: true})
  },
  removeSingleProduct(context, data) {
    cartPage()
      .removeSingleProduct(data)
      .then((data) => context.dispatch('updateCart', data));
  }
};

export default actions;
